// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width:768px){.tag[data-v-0afc3c4c]{background:linear-gradient(180deg,hsla(0,0%,100%,.24),hsla(0,0%,100%,.16))}.size[data-v-0afc3c4c]{background-image:url(/images/product-size-bg-big.svg)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
